import React, { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../firebase/firebase'

export const BibleOfTheDay = () => {
  const [verse, setVerse] = useState(null)
  const [visible, setVisible] = useState(false)
  const lang = localStorage.getItem('userLanguage') || 'ua'

  useEffect(() => {
    getDocs(collection(db, 'verses')).then(snap => {
      const list = snap.docs.map(d => d.data())
      if (list.length) setVerse(list[Math.floor(Math.random() * list.length)])
    }).catch(() => {})
  }, [])

  useEffect(() => {
    if (!verse) return
    const t = setTimeout(() => setVisible(true), 60)
    return () => clearTimeout(t)
  }, [verse])

  if (!verse) return null

  const text = lang === 'en' ? (verse.textEn || verse.text) : verse.text
  const ref  = lang === 'en' ? (verse.referenceEn || verse.reference) : verse.reference

  return (
    <div style={{ ...s.wrap, opacity: visible ? 1 : 0 }}>
      <div style={s.mark}>"</div>
      <p style={s.text}>{text}</p>
      <div style={s.ref}>— {ref}</div>
    </div>
  )
}

const s = {
  wrap: {
    width: '100%',
    boxSizing: 'border-box',
    background: '#f5ede3',
    borderRadius: '12px',
    padding: '32px 32px 28px',
    textAlign: 'center',
    boxShadow: '0 6px 20px rgba(92, 61, 46, 0.18)',
    transition: 'opacity 3s ease',
  },
  mark: {
    fontSize: '56px',
    lineHeight: '0.5',
    color: '#c4986a',
    marginBottom: '14px',
    fontFamily: 'Georgia, serif',
    userSelect: 'none',
    textShadow: '0 2px 4px rgba(139, 96, 68, 0.25)',
  },
  text: {
    fontSize: '20px',
    lineHeight: '1.75',
    color: '#2d1f14',
    fontStyle: 'italic',
    fontFamily: 'Georgia, "Times New Roman", serif',
    margin: '0 auto 16px',
    maxWidth: '680px',
    textShadow: '0 1px 0 rgba(255,255,255,0.9), 0 -1px 0 rgba(92,61,46,0.08)',
    letterSpacing: '0.15px',
  },
  ref: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#c4986a',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
    textShadow: '0 1px 0 rgba(255,255,255,0.7)',
  },
}
